import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import style from './DropdownBase.st.css';
import Popover, { placements } from '../Popover';
import DropdownLayout from '../DropdownLayout';

var DropdownBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropdownBase, _React$PureComponent);

  var _super = _createSuper(DropdownBase);

  function DropdownBase() {
    var _this;

    _classCallCheck(this, DropdownBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_dropdownLayoutRef", null);

    _defineProperty(_assertThisInitialized(_this), "_shouldCloseOnMouseLeave", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: _this.props.open,
      selectedId: _this.props.selectedId || _this.props.initialSelectedId || -1
    });

    _defineProperty(_assertThisInitialized(_this), "_isControllingOpen", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      return typeof props.open !== 'undefined';
    });

    _defineProperty(_assertThisInitialized(_this), "_isControllingSelection", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
      return typeof props.selectedId !== 'undefined' && typeof props.onSelect !== 'undefined';
    });

    _defineProperty(_assertThisInitialized(_this), "_open", function () {
      !_this._isControllingOpen() && _this.setState({
        open: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_close", function (e) {
      if (_this._isControllingOpen()) {
        return;
      } // If called within a `mouseleave` event on the target element, we would like to close the
      // popover only on the popover's `mouseleave` event


      if (e && e.type === 'mouseleave') {
        // We're not using `setState` since we don't want to wait for the next render
        _this._shouldCloseOnMouseLeave = true;
      } else {
        _this.setState({
          open: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_toggle", function () {
      !_this._isControllingOpen() && _this.setState(function (_ref) {
        var open = _ref.open;
        return {
          open: !open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClickOutside", function () {
      var onClickOutside = _this.props.onClickOutside;

      _this._close();

      onClickOutside && onClickOutside();
    });

    _defineProperty(_assertThisInitialized(_this), "_handlePopoverMouseEnter", function () {
      var onMouseEnter = _this.props.onMouseEnter;
      onMouseEnter && onMouseEnter();
    });

    _defineProperty(_assertThisInitialized(_this), "_handlePopoverMouseLeave", function () {
      var onMouseLeave = _this.props.onMouseLeave;

      if (_this._shouldCloseOnMouseLeave) {
        _this._shouldCloseOnMouseLeave = false;

        _this.setState({
          open: false
        });
      }

      onMouseLeave && onMouseLeave();
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSelect", function (selectedOption) {
      var newState = {};

      if (!_this._isControllingOpen()) {
        newState.open = false;
      }

      if (!_this._isControllingSelection()) {
        newState.selectedId = selectedOption.id;
      }

      _this.setState(newState, function () {
        var onSelect = _this.props.onSelect;
        onSelect && onSelect(selectedOption);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClose", function () {
      if (_this.state.open) {
        _this._close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_getSelectedOption", function (selectedId) {
      return _this.props.options.find(function (_ref2) {
        var id = _ref2.id;
        return id === selectedId;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_isOpenKey", function (key) {
      return ['Enter', 'Spacebar', ' ', 'ArrowDown'].includes(key);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      if (_this._isControllingOpen()) {
        return;
      }

      var isHandledByDropdownLayout = _this._delegateKeyDown(e);

      if (!isHandledByDropdownLayout) {
        if (_this._isOpenKey(e.key)) {
          _this._open();

          e.preventDefault();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_delegateKeyDown", function (e) {
      if (!_this._dropdownLayoutRef) {
        return false;
      }

      return _this._dropdownLayoutRef._onKeyDown(e);
    });

    return _this;
  }

  _createClass(DropdownBase, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Keep internal state updated if needed
      if (this._isControllingOpen(nextProps) && this.props.open !== nextProps.open) {
        this.setState({
          open: nextProps.open
        });
      }

      if (this._isControllingSelection(nextProps) && this.props.selectedId !== nextProps.selectedId) {
        this.setState({
          selectedId: nextProps.selectedId
        });
      }
    }
  }, {
    key: "_renderChildren",
    value: function _renderChildren() {
      var children = this.props.children;
      var _this$state = this.state,
          selectedId = _this$state.selectedId,
          open = _this$state.open;

      if (!children) {
        return null;
      }

      return /*#__PURE__*/React.isValidElement(children) ? children // Returning the children as is when using in controlled mode
      : children({
        open: this._open,
        close: this._close,
        toggle: this._toggle,
        isOpen: Boolean(open),
        delegateKeyDown: this._delegateKeyDown,
        selectedOption: this._getSelectedOption(selectedId)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          placement = _this$props.placement,
          appendTo = _this$props.appendTo,
          showArrow = _this$props.showArrow,
          zIndex = _this$props.zIndex,
          moveBy = _this$props.moveBy,
          options = _this$props.options,
          minWidth = _this$props.minWidth,
          maxWidth = _this$props.maxWidth,
          fixed = _this$props.fixed,
          flip = _this$props.flip,
          tabIndex = _this$props.tabIndex,
          overflow = _this$props.overflow,
          dynamicWidth = _this$props.dynamicWidth,
          maxHeight = _this$props.maxHeight,
          fluid = _this$props.fluid,
          animate = _this$props.animate;
      var _this$state2 = this.state,
          open = _this$state2.open,
          selectedId = _this$state2.selectedId;
      return /*#__PURE__*/React.createElement(Popover, _extends({
        animate: animate,
        dataHook: dataHook,
        shown: open,
        placement: placement,
        dynamicWidth: dynamicWidth,
        appendTo: appendTo,
        showArrow: showArrow,
        zIndex: zIndex,
        moveBy: moveBy,
        onKeyDown: this._handleKeyDown,
        onMouseEnter: this._handlePopoverMouseEnter,
        onMouseLeave: this._handlePopoverMouseLeave,
        onClickOutside: this._handleClickOutside,
        fixed: fixed,
        flip: flip,
        fluid: fluid
      }, style('root', {
        withWidth: Boolean(minWidth || maxWidth),
        withArrow: showArrow
      }, this.props)), /*#__PURE__*/React.createElement(Popover.Element, null, this._renderChildren()), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement("div", {
        style: {
          minWidth: minWidth,
          maxWidth: maxWidth
        }
      }, /*#__PURE__*/React.createElement(DropdownLayout, {
        dataHook: "dropdown-base-dropdownlayout",
        ref: function ref(r) {
          return _this2._dropdownLayoutRef = r;
        },
        selectedId: selectedId,
        options: options,
        maxHeightPixels: maxHeight,
        onSelect: this._handleSelect,
        onClose: this._handleClose,
        tabIndex: tabIndex,
        inContainer: true,
        visible: true,
        overflow: overflow
      }))));
    }
  }]);

  return DropdownBase;
}(React.PureComponent);

_defineProperty(DropdownBase, "displayName", 'DropdownBase');

_defineProperty(DropdownBase, "propTypes", {
  dataHook: PropTypes.string,

  /** A controlled prop to control whether the Popover should be opened*/
  open: PropTypes.bool,

  /** The Popover's placement */
  placement: PropTypes.oneOf(placements),

  /** The Popover's appendTo */
  appendTo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Whether to show the Popover's arrow */
  showArrow: PropTypes.bool,

  /** Callback function to be called on outside click */
  onClickOutside: PropTypes.func,

  /** Callback function to be called on mouseEnter on the entire component */
  onMouseEnter: PropTypes.func,

  /** Callback function to be called on mouseEnter onMouseLeave the entire component */
  onMouseLeave: PropTypes.func,

  /** Callback function to be called when selecting an option. It's signature is `onSelect(selectedOption)` */
  onSelect: PropTypes.func,

  /**
   * popovers content is set to minnimum width of trigger element,
   * but it can expand up to the value of maxWidth.
   */
  dynamicWidth: PropTypes.bool,

  /** The minimum width applied to the list */
  minWidth: PropTypes.number,

  /** The maximum width applied to the list */
  maxWidth: PropTypes.number,

  /** maximum height of dropdown box */
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The target component to be rendered. If a regular node is passed, it'll be rendered as-is.
   * If a function is passed, it's expected to return a React element. The function accepts an
   * object containing the following properties:
   *
   *  * `open` - will open the Popover
   *  * `close` - will close the Popover
   *  * `toggle` - will toggle the Popover
   *  * `isOpen` - indicates whether the items list is currently open
   *  * `delegateKeyDown` - the underlying DropdownLayout's keydown handler. It can be called
   *                        inside another keyDown event in order to delegate it.
   *  * `selectedOption` - the currently selected option
   *
   * Refer to the component documentation for more information.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Array of objects. Objects must have an `id` and can can include value and node. If value is
   * '-', a divider will be rendered instead (dividers do not require and id).
   */
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.func]).isRequired,
    disabled: PropTypes.bool,
    overrideStyle: PropTypes.bool
  }), // A divider option without an id
  PropTypes.shape({
    value: PropTypes.oneOf(['-'])
  })])),

  /** The `id` of the selected option in the list */
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Dropdown container overflow value */
  overflow: PropTypes.string,

  /** Dropdown container tabindex value */
  tabIndex: PropTypes.number,

  /**
   * The `id` of the **initial** selected option in the list, will be used when the selection
   * behaviour is being controlled
   */
  initialSelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Dropdown content z-index */
  zIndex: PropTypes.number,

  /** moves dropdown content relative to the parent by x or y */
  moveBy: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),

  /**
   * Whether to enable the flip behaviour. This behaviour is used to flip the `<Popover/>`'s placement
   * when it starts to overlap the target element (`<Popover.Element/>`).
   */
  flip: PropTypes.bool,

  /**
   * Whether to enable the fixed behaviour. This behaviour is used to keep the `<Popover/>` at it's
   * original placement even when it's being positioned outside the boundary.
   */
  fixed: PropTypes.bool,

  /** stretches trigger element to its parent container width */
  fluid: PropTypes.bool,

  /** adds enter and exit animation */
  animate: PropTypes.bool
});

_defineProperty(DropdownBase, "defaultProps", {
  placement: 'bottom',
  appendTo: 'parent',
  showArrow: false,
  maxHeight: '260px',
  fluid: false,
  animate: false
});

export default DropdownBase;